import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { Button } from '../../global/Button/Button';
// components
import { FormattedMessage } from 'react-intl';
import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import tracking from 'dibs-tracking';
import classNames from 'classnames';

function trackToggle(isExpanded) {
    return () => {
        return tracking.trackEvent({
            label: isExpanded ? 'expand' : 'collapse',
            category: 'product',
            action: 'pdp description interaction',
        });
    };
}

const showOriginalText = (
    <FormattedMessage
        id="PdpSharedDescriptionAbout.seeOriginalHeaderText"
        defaultMessage="This item description was originally written in English."
    />
);

const showTranslatedText = (
    <FormattedMessage
        id="PdpSharedDescriptionAbout.seeTranslatedHeaderText"
        defaultMessage="This description is machine-translated and may contain inaccuracies."
    />
);

const showOriginalButton = (
    <FormattedMessage
        id="PdpSharedDescriptionAbout.seeDescriptionTextButton"
        defaultMessage="See description in German"
    />
);

const showTranslatedButton = (
    <FormattedMessage
        id="PdpSharedDescriptionAbout.seeOriginalTextButton"
        defaultMessage="See original description"
    />
);

class PdpSharedDescriptionAboutComponent extends React.Component {
    constructor(props) {
        super();
        this.state = {
            showOriginal: true,
            enableTranslation: props.item.description !== props.item.englishDescription,
        };
        this.toggleDescription = this.toggleDescription.bind(this);
    }

    toggleDescription() {
        let { showOriginal } = this.state;
        showOriginal = !Boolean(showOriginal);
        this.setState({ showOriginal });
    }

    render() {
        const { headerClass, contentClass, item } = this.props;
        const { showOriginal, enableTranslation } = this.state;

        if (!item || !item.description) {
            return null;
        }

        const buttonText = showOriginal ? showOriginalButton : showTranslatedButton;
        const buttonHeader = showOriginal ? showOriginalText : showTranslatedText;
        const descriptionToShow = showOriginal ? item.englishDescription : item.description;

        return (
            <div data-tn="pdp-item-description" className={styles.wrapper}>
                <h2
                    className={classNames(styles.header, headerClass)}
                    data-tn="pdp-item-description-title"
                >
                    <FormattedMessage
                        id="PdpSharedDescriptionAbout.aboutHeader"
                        defaultMessage="About"
                    />
                </h2>
                {enableTranslation && (
                    <div className={styles.content}>
                        {buttonHeader}
                        <div className={styles.buttonMargin}>
                            <Button
                                size="small"
                                isSecondary
                                dataTn="pdp-item-description-translations"
                                onClick={() => this.toggleDescription()}
                            >
                                {buttonText}
                            </Button>
                        </div>
                    </div>
                )}
                <ExpandableContent
                    className={classNames(styles.content, contentClass)}
                    buttonClassName={styles.button}
                    onToggleReadMore={trackToggle}
                    collapseHeight={144}
                    dataTn="pdp-item-description-content"
                >
                    <span dangerouslySetInnerHTML={{ __html: descriptionToShow }} />
                </ExpandableContent>
            </div>
        );
    }
}

PdpSharedDescriptionAboutComponent.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAbout = createFragmentContainer(
    PdpSharedDescriptionAboutComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAbout_item on Item {
                description
                englishDescription
            }
        `,
    }
);
